import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import { SelectInput } from '@/modules/base/components/inputs'
import { EUER, ACCOUNTING } from './constants'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'

const ProfitDerminationInput = ({ readOnly }) => {
  const classes = useStyles()
  const options = [{ value: EUER, label: 'EÜR' }, { value: ACCOUNTING, label: 'Bilanzierung' }]

  const tooltipContent = useMemo(() => (<div className={classes.tooltipWrapper}>
    <div className={classes.tooltipTitle}>{lang.settings.taxes.profitDerminationInputTooltipHeader}</div>
    <div className={classes.tooltipContent}>{lang.settings.taxes.profitDerminationInputTooltipDescription1}</div>
  </div>
  ), [])

  return (
    <>
      <RichTooltip content={tooltipContent} width={360} placement={'top'}>
        <div className={classes.contentWrapper}>
          <SelectInput
            name='profitDerminationNames'
            className={classes.profitDermination}
            useFormik
            notAsync
            allowCreate={false}
            label={lang.settings.taxes.profitDerminationInput}
            options={options}
            customSelectOptions={{
              placeholder: lang.settings.taxes.profitDerminationInputPlaceholder,
            }}
            readOnly={readOnly}
          />
        </div>
      </RichTooltip>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    width: '100%',
  },
  profitDermination: {
    width: '100%',
  },
  tooltipWrapper: {
    height: 'fit-content',
    color: theme.black,
  },
  tooltipTitle: {
    paddingBottom: '20px',
    textAlign: 'center',
    fontSize: theme.fontSizes.default,
    lineHeight: '20px',
    color: theme.black,
    fontWeight: theme.fontWeights.bold,
  },
  tooltipContent: {
    fontSize: theme.fontSizes.smaller,
    marginTop: 10,
  },
}))

export default ProfitDerminationInput
